import { cn } from '../lib/cn';

/** Универсальный скелетон-плейсхолдер загрузки. */
export function Skeleton({ className }: { className?: string }) {
  return <div className={cn('animate-pulse rounded-md bg-border', className)} />;
}
